// extracted by mini-css-extract-plugin
export var clamp = "styles-module__clamp___Ty7TE";
export var showMore = "styles-module__showMore___JLwEb";
export var showMoreContainer = "styles-module__showMoreContainer___gV1Je";
export var trailOverview = "styles-module__trailOverview___L9YWh";
export var trailOverviewContainer = "styles-module__trailOverviewContainer___SsaU0";